import { gql } from '@apollo/client';
import { useHotToast } from 'src/utils/useHotToast';
import { useLoginAsShopFromEmployeeLazyQuery } from './__generated__/useLoginAsShopFromEmployee.generated';
import { useAuthContext } from 'src/Components/AuthContext';

export function useLoginAsShop() {
  const toast = useHotToast();
  const authContext = useAuthContext();
  const [loginAsShop, { loading: isLoggingAsShop }] =
    useLoginAsShopFromEmployeeLazyQuery({
      fetchPolicy: 'network-only',
      onError: e => {
        toast.error(e.message);
      },
    });

  return {
    loginAsShop: (onSuccess?: () => void) => {
      const shopLocationId = authContext.user?.shopLocation?.id;
      if (!shopLocationId) {
        toast.error('Cannot logout as employee');
      } else {
        loginAsShop({
          variables: {
            input: { shopLocationId },
          },
          onCompleted: res => {
            authContext.onLogin(res.loginAsShop);
            if (onSuccess) {
              onSuccess();
            }
          },
        });
      }
    },
    isLoggingAsShop,
  };
}

const LOGIN_AS_SHOP = gql`
  query LoginAsShopFromEmployee($input: LoginAsShopInput!) {
    loginAsShop(input: $input) {
      user {
        id
        companyName
        authUserType
      }
      token
      authTokenType
      shopLocation {
        id
        name
      }
    }
  }
`;
